module.exports = __webpack_public_path__ + "static/media/youngGardenPlants.8748b853.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/youngGardenPlants.jpg
// module id = 203
// module chunks = 0